/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Privacy_DescriptionInputs */



/**
* | output |
* | --- |
* | "How we collect, use and protect your data." |
*
* @param {Legal_Privacy_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const legal_privacy_description = /** @type {((inputs?: Legal_Privacy_DescriptionInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Privacy_DescriptionInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Comment nous collectons, utilisons et protégeons vos données.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cómo recogemos, usamos y protegemos sus datos.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Como coletamos, usamos e protegemos seus dados.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Come raccogliamo, utilizziamo e proteggiamo i vostri dati.")
	return /** @type {LocalizedString} */ ("How we collect, use and protect your data.")
});